import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../../components/common/LoadingSpinner";

function QuickShorten() {
  const { apiKey } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const shortenAndRedirect = async () => {
      const url = searchParams.get("url");

      if (!url) {
        setError("URL is required");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/qs/${apiKey}?url=${encodeURIComponent(url)}`
        );

        // Backend handles the redirect, but as a fallback
        if (response.data?.success && response.data?.data?.shortUrl) {
          window.location.href = response.data.data.shortUrl;
        } else {
          setError("Failed to shorten link");
        }
      } catch (err) {
        setError(
          err.response?.data?.error?.message ||
            "Error occurred while shortening link"
        );
      }
    };

    shortenAndRedirect();
  }, [apiKey, searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-xl font-medium text-red-600 mb-2">Hata!</h2>
          <p className="text-gray-600">{error}</p>
          <button
            onClick={() => navigate("/")}
            className="mt-4 btn btn-primary"
          >
            Ana Sayfa
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <LoadingSpinner text="Link kısaltılıyor ve yönlendiriliyor..." />
      </div>
    </div>
  );
}

export default QuickShorten;
